import React, { Component } from 'react';
import Table from './components/Table';
import sourceData from './data/data.json';
import _ from 'lodash';
import Filters from './components/Filters';
import termos from './data/termos.json';

const pauperData = sourceData.Plan1.map((row) => {
  row.citacao_html = row.citacao;
  row.citacao_html = row.citacao_html.replace(
    row.termo_original,
    `<strong>${row.termo_original}</strong>`
  );
  row.citacao_html = row.citacao_html.replace(
    row.termo_original.toUpperCase(),
    `<strong>${row.termo_original.toUpperCase()}</strong>`
  );
  row.citacao_html = row.citacao_html.replace(
    row.termo_original.charAt(0).toUpperCase() + row.termo_original.slice(1),
    `<strong>${
      row.termo_original.charAt(0).toUpperCase() + row.termo_original.slice(1)
    }</strong>`
  );
  return row;
});

const includesValue = (val, obj) =>
  _.some(obj, (v) => _.includes(v.toLowerCase(), val.toLowerCase()));

class Main extends Component {
  state = {
    data: pauperData,
    filteredData: pauperData,
    filter: {
      termSearch: '',
      divisao_mgh: '',
      tipo_documental: '',
      conjunto_documental: '',
      lema: '',
    },
  };
  changeTerm = (e) => {
    const filter = { ...this.state.filter, termSearch: e.target.value };

    this.setState({ filter }, () => this.filterData());
  };
  handleSelect = (e, prop) => {
    let filter = { ...this.state.filter };
    const value = e.target.value;
    filter[prop] = value;

    this.setState({ filter }, () => this.filterData());
  };
  filterData = () => {
    const filter = { ...this.state.filter };
    let filteredData = this.state.data.filter((row) => {
      let result = true;
      if (filter.tipo_documental !== '') {
        result =
          row.tipo_documental_1
            .toLowerCase()
            .includes(filter.tipo_documental.toLowerCase()) ||
          row.tipo_documental_2
            .toLowerCase()
            .includes(filter.tipo_documental.toLowerCase()) ||
          row.tipo_documental_3
            .toLowerCase()
            .includes(filter.tipo_documental.toLowerCase());
      }
      if (filter.conjunto_documental !== '') {
        result =
          result &&
          row.conjunto_documental
            .toLowerCase()
            .includes(filter.conjunto_documental.toLowerCase());
      }
      if (filter.divisao_mgh !== '') {
        result =
          result &&
          row.divisao_mgh
            .toLowerCase()
            .includes(filter.divisao_mgh.toLowerCase());
      }
      if (filter.termSearch !== '') {
        result = result && includesValue(this.state.filter.termSearch, row);
      }
      if (filter.lema !== '') {
        let bool = false;
        termos[filter.lema].forEach((termo) => {
          if (row.termo_original === termo) {
            bool = true;
          }
        });
        result = result && bool;
      }
      return result;
    });
    this.setState({ filteredData });
    window.scrollTo(0, 0);
  };
  downloadAsCSV = () => {
    var json = this.state.filteredData;
    var fields = Object.keys(json[0]);
    var replacer = function (key, value) {
      return value === null ? '' : value;
    };
    var csv = json.map(function (row) {
      return fields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(',');
    });
    csv.unshift(fields.join(',')); // add header column
    csv = csv.join('\r\n');

    const element = document.createElement('a');
    const file = new Blob([csv], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'pauper_data.csv';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  downloadAsJSON = () => {
    var json = JSON.stringify(this.state.filteredData);
    const element = document.createElement('a');
    const file = new Blob([json], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'pauper_data.json';
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  cleanFilters = () => {
    const filter = {
      termSearch: '',
      divisao_mgh: '',
      tipo_documental: '',
      conjunto_documental: '',
      lema: '',
    };
    this.setState({ filter }, () => this.filterData());
  };
  render() {
    const { filteredData, filter } = this.state;
    return (
      <div>
        {/* <Header /> */}
        <Filters
          filter={filter}
          handleCleanFilters={this.cleanFilters}
          handleChangeSelect={this.handleSelect}
          handleChangeInput={this.changeTerm}
          handleDownloadAsCSV={this.downloadAsCSV}
          handleDownloadAsJSON={this.downloadAsJSON}
          dataLength={filteredData.length}
        />
        <div className="spacer"></div>
        {filteredData.length ? (
          <Table data={filteredData} />
        ) : (
          <div className="container mt-5 text-center no-results">
            <h3>
              Não foram encontradas ocorrências para os filtros selecionados.
            </h3>
          </div>
        )}
      </div>
    );
  }
}

export default Main;
